module.exports = __webpack_public_path__ + "static/media/redux.d291ed5f.svg";